import styled from '@emotion/styled'
import * as api from "api"
import RatioElement from "common/ElementRatio"
import ResponsiveModelImage from "common/ResponsiveModelImage"
import GalleryDialog from "components/dialogs/GalleryDialog"
import { memo, useState } from "react"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    margin: 30px 0 5px;
    overflow: hidden;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 0;
    }
  `,
  Grid: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 9px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      grid-gap: 3px;
      margin-top: 20px;
    }
  `,
  ImageContainer: styled.div`
    width: 100%;
    cursor: pointer;
  `,
}

type VehicleTilesProps = { data: api.VehicleTiles }

const VehicleTiles = ({ data }: VehicleTilesProps) => {
  const [activeDialog, setActiveDialog] = useState<number>(null)
  return (
    <Styled.Wrapper>
      <Shared.Mobile>
        <Shared.Header>גלריה</Shared.Header>
        <Shared.Divider />
      </Shared.Mobile>
      <Styled.Grid>
        {data.images.map((image, i) => (
          <Styled.ImageContainer key={i} onClick={() => setActiveDialog(i)}>
            <RatioElement ratio={1 / 1}>
              <ResponsiveModelImage image={image} cover imageSizes="33vw" />
            </RatioElement>
          </Styled.ImageContainer>
        ))}
      </Styled.Grid>
      <GalleryDialog
        images={data.images}
        active={activeDialog}
        onClose={() => setActiveDialog(null)}
      />
    </Styled.Wrapper>
  )
}

export default memo(VehicleTiles)
